import React, { useState } from "react";
// import ImageDisplay from "../../../core/img/imageDisplay";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import Table from "../../../core/pagination/datatable";
import ImageHandlerModal from "./ImageHandlerModal";
import { ImageDataModalRequired } from "../constants";
import ImageDisplay from "../../../core/img/imageDisplay";
import "./custom.css";

const MultipleImage = ({
  id,
  dataSource,
  setDataSource,
  DataRequired,
  DataLimit,
}) => {
  const [Selecteddata, setSelecteddata] = useState({});
  const RemoveData = async (key) => {
    setDataSource((prev) => prev.filter((item) => item.key !== key));
  };
  const onNewAdd = (data) => {
    if (data) {
      setDataSource((prev) => {
        const existingIndex = prev.findIndex((item) => item.key === data.key);

        if (existingIndex !== -1) {
          // 🔄 Replace existing entry
          return prev.map((item) =>
            item.key === data.key ? data : { ...item, dev: true }
          );
        } else {
          return [...prev, { ...data, key: Date.now().toString(), dev: true }];
        }
      });
    }
  };

  const renderRefreshTooltip = (props, Data) => (
    <Tooltip id="refresh-tooltip" {...props}>
      {Data}
    </Tooltip>
  );

  const columnsBuilder = {
    [ImageDataModalRequired.image]: {
      title: "Image",
      dataIndex: "image",
      render: (text, record) => (
        <span className="productimgname">
          <Link to="#" className="product-img stock-img">
            {record?.dev && record.image instanceof Blob ? (
              <img src={URL.createObjectURL(record.image)} />
            ) : (
              <ImageDisplay alt="" src={record?.image} />
            )}
          </Link>
        </span>
      ),
    },
    [ImageDataModalRequired.heading]: {
      title: "Title",
      dataIndex: "heading",
      render: (data) => <div dangerouslySetInnerHTML={{ __html: data }} />,
    },
    [ImageDataModalRequired.description]: {
      title: "Description",
      dataIndex: "subHeading",
      render: (data) => (
        <div
          className="rendered-html"
          dangerouslySetInnerHTML={{ __html: data }}
        />
      ),
    },
    [ImageDataModalRequired.buttonText]: {
      title: "Button text",
      dataIndex: "ctaBtn",
    },
    [ImageDataModalRequired.buttonLink]: {
      title: "Button Link",
      dataIndex: "ctaLink",
    },
  };
  const defaultColoumn = [
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <OverlayTrigger
              placement="top"
              overlay={(d) => renderRefreshTooltip(d, "Edit")}
            >
              <Link
                className="me-2 p-2"
                to="#"
                data-bs-toggle="modal"
                data-bs-target={`#new-image-modal-${id}`}
                onClick={() => setSelecteddata(record)}
              >
                <i data-feather="edit" className="feather-edit"></i>
              </Link>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={(d) => renderRefreshTooltip(d, "Delete")}
            >
              <Link
                className="confirm-text p-2"
                onClick={() => RemoveData(record?.key)}
              >
                <i data-feather="trash-2" className="feather-trash-2"></i>
              </Link>
            </OverlayTrigger>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div>
        {(!DataLimit || DataLimit > dataSource?.length) && (
          <div className="d-flex justify-content-end">
            <div
              className="btn btn-primary "
              data-bs-toggle="modal"
              data-bs-target={`#new-image-modal-${id}`}
            >
              {" "}
              Add
            </div>
          </div>
        )}

        {DataLimit && DataLimit <= 1 && dataSource?.length === 1 && (
          <div className="d-flex justify-content-end">
            <div
              className="btn btn-primary "
              data-bs-toggle="modal"
              data-bs-target={`#new-image-modal-${id}`}
              onClick={() => setSelecteddata(dataSource?.[0] || {})}
            >
              {" "}
              Edit
            </div>
          </div>
        )}
        <div
          className="table-responsive"
          // style={{ position: "relative", zIndex: 1 }}
        >
          {dataSource?.length > 0 ? (
            DataLimit && DataLimit <= 1 && dataSource?.length === 1 ? (
              <>
                <div className="d-flex">
                  <div
                    style={{
                      height: "200px",
                      width: "400px",
                      overflow: "hidden",
                    }}
                  >
                    {dataSource?.[0]?.dev &&
                    dataSource?.[0].image instanceof Blob ? (
                      <img src={URL.createObjectURL(dataSource?.[0].image)} />
                    ) : (
                      <ImageDisplay alt="" src={dataSource?.[0]?.image} />
                    )}
                  </div>

                  <div className="ms-3">
                    <p
                      className="rendered-html"
                      dangerouslySetInnerHTML={{
                        __html: dataSource?.[0]?.heading,
                      }}
                    />
                    <p
                      className="rendered-html"
                      dangerouslySetInnerHTML={{
                        __html: dataSource?.[0]?.subHeading,
                      }}
                    />
                  </div>
                </div>
                <hr />
              </>
            ) : (
              <Table
                columns={[
                  ...DataRequired.map((i) => columnsBuilder[i]),
                  ...defaultColoumn,
                ]}
                dataSource={dataSource}
                setDataSource={setDataSource}
                // dataSource, setDataSource
              />
            )
          ) : (
            <div className="text-center">
              <p style={{ fontWeight: "700" }}>No data uploaded</p>
              <hr />
            </div>
          )}
        </div>
      </div>
      <ImageHandlerModal
        id={id}
        editData={Selecteddata}
        onFinish={onNewAdd}
        DataRequired={DataRequired}
      />
    </>
  );
};

export default MultipleImage;
